import React from 'react';
import classNames from 'classnames';

export const InputText = ({
  type,
  name,
  value,
  onChange,
  label,
  placeholder,
  errorText,
  accept,
  fullWidth,
  style
}) => {
  return (
    <div className={classNames('input-text-container', {w100: fullWidth})} style={style}>
      <label htmlFor={name} className='input-text-label'>{label}</label>
      <input
        id={name}
        type={type}
        name={name}
        value={value}
        accept={accept}
        onChange={onChange}
        placeholder={placeholder}
        className='input-text'
      />
      {!!errorText && (
        <div style={{
          position: 'relative',
          bottom: '-8px',
          fontSize: '12px',
          lineHeight: '12px',
          color: 'rgb(255, 87, 34)',
          transition: '450ms cubic-bezier(0.23, 1, 0.32, 1)'
        }}>
          {errorText}
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/modules/blocks/inputs/InputText.js